class APIError extends Error {
    constructor(response, options) {
        let message = "Unknown error occurred.";
        if (typeof response.error === "string") {
            message = response.error;
        }
        if (response.error.message) {
            message = response.error.message;
        }
        super(message, options);
        this.response = response;
        if (response.error.name) {
            this.name = response.error.name;
        }
    }
}
export default APIError;
//# sourceMappingURL=api-error.js.map